import React from "react";
import { Routes, Route } from "react-router-dom";
import HashScroll from "./components/HashScroll";

import Index from "./page/index";
import About from "./page/about";
import Story from "./page/story";
import Company from "./page/company";
import Teams from "./page/teams";
import Vision from "./page/vision";
import Services from "./page/services";
import ServiceDetail from "./page/serviceDetail";
import Innovation from "./page/innovation";
import InnovationDetail from "./page/innovationDetail";
import Blog from "./page/blog";
import BlogDetail from "./page/blogDetail";
import Booking from "./page/booking";
import Career from "./page/career";
import Login from "./page/login";
import Register from "./page/register";
import Notfound from "./page/notfound";

const AppRoutes = () => (
  <>
    <HashScroll />
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/about" element={<About />} />
      <Route path="/story" element={<Story />} />
      <Route path="/company" element={<Company />} />
      <Route path="/teams" element={<Teams />} />
      <Route path="/vision" element={<Vision />} />
      <Route path="/services" element={<Services />} />
      <Route path="/service" element={<Services />} />
      <Route path="/services/:cat/:item" element={<ServiceDetail />} />
      <Route path="/innovation" element={<Innovation />} />
      <Route path="/innovation/:slug" element={<InnovationDetail />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogDetail />} />
      <Route path="/booking" element={<Booking />} />
      <Route path="/career" element={<Career />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/*" element={<Notfound />} />
    </Routes>
  </>
);

export default AppRoutes;
